module.exports = __webpack_public_path__ + "img/primeo-energie.0298e777.png";